import { types } from 'mobx-state-tree';
import { SiteTypeType } from '../types/Site';

const Site = types.model('Site', {
  type: types.maybeNull(SiteTypeType),
  section_id: types.maybeNull(types.number)
});

export default Site;



// WEBPACK FOOTER //
// ./src/models/Site.js